import * as React from 'react';
import ResetPassword from '../ResetPassword';

class SetPassword extends React.Component {
  public render() {
    return (
      <ResetPassword
        {...this.props}
        title={'Set Password'}
        message={'Your password has been set, please login to access your account.'}
      />
    );
  }
}

export default SetPassword;
